module.exports = __webpack_public_path__ + "img/icon-whatsapp.cba17ff7.png";